// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"b0788824","63":"6230f621","262":"db1e1686","291":"9a9ae9c7","301":"3dcef052","375":"788a3f18","689":"22172266","730":"80dece53","809":"76cd9b1a","960":"1b4c9f1c"}[chunkId] + ".chunk.js";
};